import { render, staticRenderFns } from "./PopoverLogo.vue?vue&type=template&id=76a93538"
import script from "./PopoverLogo.vue?vue&type=script&lang=js"
export * from "./PopoverLogo.vue?vue&type=script&lang=js"
import style0 from "./PopoverLogo.vue?vue&type=style&index=0&id=76a93538&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports